import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useCallback } from 'react';
import { Image, View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { useDimensionAnimation } from '../Animations/AnimationHooks';
import { AnimatedPressable } from '../Buttons/AnimatedPressable';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
export const ChipsView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.chips,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign({ minHeight: 32, padding: 4, backgroundColor: '#F0F3F7', borderRadius: 16, flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center' }, props.containerStyle),
            image: Object.assign({ height: 24, width: 24, overflow: 'hidden', borderRadius: 12 }, props.imageContainerStyle),
            textContainer: {
                marginHorizontal: 8,
                justifyContent: 'center'
            },
            text: Object.assign({ fontSize: 14, lineHeight: 24 }, props.textStyle),
            btn: {
                height: 16,
                width: 16,
                backgroundColor: '#A3B3C6',
                borderRadius: 8,
                justifyContent: 'center',
                alignItems: 'center'
            },
            btnText: {
                color: '#F0F3F7',
                fontSize: 12,
                lineHeight: 16
            }
        };
    }
})(({ style, image, icon, title, onDelete, onPress }) => {
    const [imageAnimation, setImageAnimation] = useDimensionAnimation({
        initialValue: 0,
        duration: 200
    });
    useEffect(() => {
        icon && setImageAnimation(1);
    }, [icon]);
    const handleImageLoad = useCallback(() => {
        setImageAnimation(1);
    }, []);
    return (_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.container, children: [(image || icon) && (_jsx(View, { children: _jsxs(AnimatedPressable, { testID: `button-${title}`, style: [style === null || style === void 0 ? void 0 : style.image, { opacity: imageAnimation }], onPress: onPress, children: [!!icon && icon(), !icon && !!image && (_jsx(Image, { source: { uri: image }, style: { width: '100%', height: '100%' }, resizeMode: 'cover', onLoad: handleImageLoad }))] }) })), !!title && (_jsx(View, { style: { flex: 1 }, children: _jsx(AnimatedPressable, { onPress: onPress, style: style === null || style === void 0 ? void 0 : style.textContainer, children: _jsx(AnimatedTextView, { textStyle: style === null || style === void 0 ? void 0 : style.text, children: title }) }) })), !!onDelete && (_jsx(View, { children: _jsx(AnimatedPressable, { onPress: onDelete, style: style === null || style === void 0 ? void 0 : style.btn, children: _jsx(AnimatedTextView, { textStyle: style === null || style === void 0 ? void 0 : style.btnText, children: "x" }) }) }))] }));
});
